import React from 'react';
import { DayScale } from './scale';
import { ETRuler } from './types';
import { timelineColors, timelineFontWeight } from './tokens';

// Restyled version of the design's anchor band + "Experience start" pill:
// an 'anchor'-emphasis ruler gets a full-height shaded column + bold line +
// dark pill; a 'plain' ruler gets a thin line + light pill.
export const RulerBands = React.memo(
  ({
    rulers,
    scale,
    canvasHeight,
    headerHeight
  }: {
    rulers: ETRuler[];
    scale: DayScale;
    canvasHeight: number;
    headerHeight: number;
  }) => (
    <>
      {rulers.map((r) => {
        const isAnchor = r.emphasis === 'anchor';
        const x = scale.xOfDayCenter(r.day);
        // The pill is centered on its day, so at the extreme edges (experience
        // start/end) it would spill past the canvas and trip a scrollbar even
        // when the grid itself fits. Nudge the pill inward to stay within
        // [labelWidth, totalWidth] — the tick line stays on the true day.
        // Half-width is estimated from the label (same 6.2px/char heuristic the
        // layout uses); a slight over-estimate is fine, it just seats the pill
        // a touch further from the edge.
        const pillHalf = (r.label.length * 6.2 + 20) / 2;
        const pillX = Math.min(
          Math.max(x, scale.labelWidth + pillHalf),
          scale.totalWidth - pillHalf
        );
        return (
          <React.Fragment key={`ruler-${r.day}-${r.label}`}>
            {isAnchor && (
              <div
                style={{
                  position: 'absolute',
                  left: scale.xOfDayEdge(r.day),
                  top: headerHeight,
                  width: scale.colWidth,
                  height: canvasHeight - headerHeight,
                  background: timelineColors.bandFill,
                  zIndex: 1
                }}
              />
            )}
            <div
              style={{
                position: 'absolute',
                left: x - (isAnchor ? 1 : 0.5),
                top: 15,
                width: isAnchor ? 2 : 1,
                height: headerHeight - 15,
                background: isAnchor ? timelineColors.ink : timelineColors.lineStrong,
                zIndex: 4
              }}
            />
            <div
              style={{
                position: 'absolute',
                left: pillX,
                top: 15,
                transform: 'translate(-50%, -50%)',
                background: isAnchor ? timelineColors.surface : timelineColors.border,
                border: isAnchor ? `1.5px solid ${timelineColors.ink}` : 'none',
                color: isAnchor ? timelineColors.ink : timelineColors.textMuted,
                fontSize: 11,
                fontWeight: timelineFontWeight.label,
                padding: '3px 10px',
                borderRadius: isAnchor ? 10 : 6,
                whiteSpace: 'nowrap',
                zIndex: 5
              }}
            >
              {r.label}
            </div>
          </React.Fragment>
        );
      })}
    </>
  )
);
